<template>
    <div id="school-question-quiz">
        <div class="vx-card p-6">

            <div class="">
                <div>
                    <label class="vs-input--label required">{{ $t('multipleChoice.question') }}</label>
                    <vs-textarea class="w-full" v-model="question.questionName" name="questionName"
                        v-validate="'required'" />
                    <span class="text-danger text-sm">{{ errors.first('questionName') }}</span>
                </div>
                <!-- <div class="vx-col md:w-1/4 w-full">
                <label class="vs-input--label">Chọn loại câu hỏi</label>
                <v-select class="" v-model="question.questionType" :options="typeOfQuestions" :clearable="false"
                    :reduce="(option) => option.value">
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                </v-select>
            </div> -->
                <div class="mt-4">
                    <h5 class="mb-4">{{ $t('multipleChoice.question_type') }}</h5>
                    <div>
                        <vs-radio v-model="question.questionType" vs-value="1" class="mr-4"
                            vs-name="layout-type-vertical">{{ $t('multipleChoice.question_simple') }}
                        </vs-radio>
                        <vs-radio v-model="question.questionType" vs-value="2" class="mr-4"
                            vs-name="layout-type-horizontal">{{ $t('multipleChoice.question_media') }}
                        </vs-radio>
                    </div>
                </div>
                <vs-button icon-pack="feather" icon="icon-plus" color="primary" @click="openPopupAddFiles" class="mt-6"
                    v-if="question.questionType == 2">{{ $t('multipleChoice.addFile') }}
                </vs-button>

                <vs-popup title="Tải lên file" :active.sync="popupUploadFiles" id="popup-upload-file">
                    <div class="vx-row">
                        <div class="vx-col w-full flex flex-wrap mt-4">
                            <div class="flex justify-center upload">
                                <div class="file-upload" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                                    <input ref="file" type="file" id="imageUpload" multiple class="hidden"
                                        @change="uploadFile()">
                                    <div class="mx-auto">
                                        <div class="text-center">
                                            <feather-icon icon="UploadCloudIcon" svgClasses="h-10 w-10 text-primary" />
                                        </div>
                                        <div class="text-center button-upload">
                                            <vs-button @click="$refs.file.click()">{{ $t('multipleChoice.upload')
                                                }}</vs-button>
                                        </div>
                                        <div class="text-center mt-4">
                                            <label class="file-label text-primary">
                                                <div v-if="isDragging">{{ $t('multipleChoice.isDragging') }}</div>
                                                <div v-else>{{ $t('multipleChoice.outDragging') }}</div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-files mt-2 ml-8" v-if="question.questionType == 2">
                                <vs-table stripe :pagination="question.files.length > 0" maxItems="4"
                                    :data="question.files" noDataText="Không có dữ liệu">
                                    <template slot="thead">
                                        <vs-th>
                                            STT
                                        </vs-th>
                                        <vs-th>
                                            {{ $t('multipleChoice.name') }}
                                        </vs-th>
                                        <vs-th>
                                            {{ $t('multipleChoice.actions') }}
                                        </vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                            <vs-td>
                                                {{ indextr + 1 }}
                                            </vs-td>

                                            <vs-td class="text-primary">
                                                {{ tr.name }}
                                            </vs-td>

                                            <vs-td>
                                                <div class="flex items-center">
                                                    <vx-tooltip class="position-icon" :text="$t('button.delete')"
                                                        position="top">
                                                        <feather-icon icon="TrashIcon" class="action-err icon-btn"
                                                            svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                                            @click="confirmDeleteRecord(indextr)" />
                                                    </vx-tooltip>
                                                </div>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>

                        </div>
                        <div class="vx-col w-full mt-4 flex justify-end gap-2">
                            <vs-button @click="addFile">{{ $t('multipleChoice.addFile') }} </vs-button>
                            <vs-button color="danger" type="border" @click="popupUploadFiles = false">{{
                        $t('multipleChoice.back') }}
                            </vs-button>
                        </div>
                    </div>
                </vs-popup>
                <div class="table-files mt-2" v-if="question.questionType == 2">
                    <vs-table stripe :pagination="question.files.length > 0" maxItems="4" :data="question.files"
                        noDataText="Không có dữ liệu">
                        <template slot="thead">
                            <vs-th>
                                {{ $t('multipleChoice.stt') }}
                            </vs-th>
                            <vs-th>
                                {{ $t('multipleChoice.name') }}
                            </vs-th>
                            <vs-th>
                                {{ $t('multipleChoice.actions') }}
                            </vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    {{ indextr + 1 }}
                                </vs-td>

                                <vs-td class="text-primary">
                                    {{ tr.name }}
                                </vs-td>

                                <vs-td>
                                    <div class="flex items-center">
                                        <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                                            <feather-icon icon="TrashIcon" class="action-err icon-btn"
                                                svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                                @click="confirmDeleteRecord(indextr)" />
                                        </vx-tooltip>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
                <div class="mt-4">
                    <h5 class="mb-4">{{ $t('multipleChoice.answer_type') }}</h5>
                    <div>
                        <vs-radio v-model="question.questionOptionType" vs-value="1" class="mr-4">{{
                        $t('multipleChoice.answer_one') }}
                        </vs-radio>
                        <vs-radio v-model="question.questionOptionType" vs-value="2" class="mr-4">{{
                        $t('multipleChoice.answer_multiple') }}
                        </vs-radio>
                    </div>
                </div>
                <div class="vx-row mt-4">
                    <div v-for="(option, index) in question.options" :key="index" class="vx-col md:w-1/2 w-full mb-4">
                        <label class="vs-input--label required">{{ $t('multipleChoice.option') }} {{ index + 1
                            }}</label>
                        <div class="flex gap-4">
                            <vs-input class="flex-auto" type="text" v-model="option.optionName" :name="`option${index}`"
                                v-validate="'required'" />
                            <div class="flex items-center">
                                <vs-checkbox v-model="option.status"
                                    v-if="question.questionOptionType == 2"></vs-checkbox>
                                <vs-radio v-model="option.status" class="mr-4" vs-value="true" vs-name="true"
                                    v-if="question.questionOptionType == 1">
                                </vs-radio>
                                <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                                    <feather-icon icon="XIcon" class="text-danger" svg-classes="h-5 w-5"
                                        @click="deleteOption(index)">
                                    </feather-icon>
                                </vx-tooltip>
                            </div>
                        </div>
                        <span class="text-danger text-sm">{{ errors.first(`option${index}`) }}</span>
                    </div>
                </div>
                <div class="flex">
                    <vs-button icon="icon-plus" icon-pack="feather" color="warning" type="border" @click="addOption()">
                        {{ $t('button.addOption') }}
                    </vs-button>
                    <vs-button icon="icon-check" icon-pack="feather" color="primary" class="ml-auto"
                        :disabled="!validateForm" @click="saveQuestion">
                        {{ $t('button.save') }}
                    </vs-button>
                    <vs-button icon="icon-x" icon-pack="feather" color="danger" type="border" @click="resetForm"
                        class="ml-2" v-if="question.questionName">
                        {{ $t('button.cancel') }}
                    </vs-button>
                </div>

            </div>
        </div>
        <vx-card class="vx-card pt-4 mt-6" v-if="listQuestion.length > 0">
            <h3>{{ $t('dashboard.listQuestion') }}</h3>
            <ag-grid-vue style="height: 55vh" ref="agGridTable" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="listQuestion" :animateRows="true"
                :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }" @grid-ready="onGridReady"
                :autoSizeStrategy="autoSizeStrategy">
            </ag-grid-vue>
            <div class="vx-row mt-8" v-if="totalElements > 0">
                <div class="vx-col md:w-1/2 w-full">
                    <span class="content-page font-bold">{{ $t('dashboard.display') }} </span>
                    <span class="text-page">
                        {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{
                        totalElements
                        }}
                    </span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import CellRendererActionQuestion from "./cell-renderer/CellRendererActionQuestion";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import { ModuleRegistry } from '@ag-grid-community/core';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        AgGridVue,
        CellRendererActionQuestion
    },
    data() {
        return {
            popupUploadFiles: false,
            gridApi: null,
            topicId: null,
            // typeOfQuestions: [{
            //     value: 1, label: 'Loại Thường'},
            //     { value: 2, label: 'Loại có media' }],

            question: {
                options: [
                    {
                        optionName: null,
                        status: false
                    },
                    {
                        optionName: null,
                        status: false,
                    }
                ],
                questionName: null,
                score: null,
                topicId: null,
                questionType: 1,
                questionOptionType: 1,
                files: [],

            },
            optionSelect: null,
            selectedOption: null,
            pageNumber: 0,
            pageSize: 20,
            currentPage: 1,
            totalPages: 0,
            totalElements: 0,
            countElementPage: 0,
            listQuestion: [],
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('multipleChoice.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('multipleChoice.question'),
                    field: 'questionName',
                    width: 300,
                },
                {
                    headerName: this.$t('multipleChoice.stt'),
                    field: 'createdDateCvt',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.updatedDate'),
                    field: 'modifiedDateCvt',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.actions'),
                    field: 'actions',
                    width: 200,
                    cellRenderer: 'CellRendererActionQuestion',
                    suppressSizeToFit: true,
                },
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            isDragging: false,
        }
    },

    watch: {
        '$store.state.isUpdateQuestion'(val) {
            if (val) {
                this.question.questionType = null
                this.question = val
                this.$store.commit('UPDATE_QUESTION', null);
                // document.body.scrollTop = 0; // Cho Safari
                // document.documentElement.scrollTop = 0; // Cho Chrome, Firefox, IE và Opera
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },

        '$store.state.isDeleteQuestion'(val) {
            if (val) {
                this.resetForm();
                this.pageNumber = 0;
                this.currentPage = 1;
                this.getAllQuestionInTopic();
                this.$store.commit('DELETE_QUESTION', false);
            }
        },
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },

    created() {
        this.topicId = this.$route.query.topicId;
        this.getAllQuestionInTopic();
    },

    methods: {
        openPopupAddFiles() {
            this.question.files = []
            this.popupUploadFiles = true
        },
        dragover(e) {
            e.preventDefault()
            this.isDragging = true
        },
        dragleave() {
            this.isDragging = false
        },
        drop(e) {
            e.preventDefault()
            this.$refs.file.files = e.dataTransfer.files
            this.uploadFile()
            this.isDragging = false
        },

        uploadFile() {
            let file = this.$refs.file.files
            this.question.files.push(...file);
            this.$refs.file.value = null
        },
        addFile() {
            this.uploadFile();
            this.popupUploadFiles = false
        },
        confirmDeleteRecord(indextr) {
            this.question.files.splice(indextr, 1)
        },
        async saveQuestion(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            let answer = this.question.options.find(el => el.status)
            if (!answer) {
                return this.$vs.notify({
                    text: this.$t('multipleChoice.notice_option_simple'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            this.question.topicId = parseInt(this.topicId, 10);
            // this.question.options.map(el => {
            //      el.status = this.optionSelect
            // })
            let formData = new FormData(), config = {};
            config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            };
            const blob = new Blob([JSON.stringify(this.question)], { type: 'application/json' });
            formData.append('dto', blob);
            if (this.question.files && this.question.files.length > 0) {
                this.question.files.forEach(file => {
                    formData.append('files', file);
                });
            }
            let url = this.question.id ? `/school-question-quiz/update/${this.question.id}` : '/school-question-quiz/create'
            this.$vs.loading();
            this.$crm.post(url, formData, config).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: `${this.question.id ? 'Cập nhật' : 'Thêm mới'} câu hỏi thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success',
                });
                this.resetForm()
                this.getAllQuestionInTopic();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        addOption() {
            this.question.options.push({
                optionName: null,
                status: false
            });
        },

        deleteOption(index) {
            this.question.options.splice(index, 1)
        },

        getAllQuestionInTopic() {
            let payload = {
                topicId: parseInt(this.topicId, 10),
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            }

            this.$vs.loading();
            this.$crm.post('/school-question-quiz/find-by-condition', payload).then(res => {
                if (res.data.content.length > 0) {
                    this.listQuestion = res.data.content.map(el => {
                        el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                        el.createdDateCvt = moment(el.createdDate).format('DD/MM/YYYY HH:mm:ss');
                        el.modifiedDateCvt = moment(el.modifiedDate).format('DD/MM/YYYY HH:mm:ss');
                        return el;
                    })
                } else {
                    this.listQuestion = []
                }
                this.countElementPage = this.currentPage * this.pageSize;
                this.totalElements = res.data.totalElements;
                this.totalPages = res.data.totalPages;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onGridReady(params) {
            this.gridApi = params.api;
        },

        loadPage: function (currentPage) {
            if (parseInt(currentPage) - 1 != this.pageNumber) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllQuestionInTopic();
            }
        },

        resetForm() {
            this.question = {
                options: [
                    {
                        optionName: null,
                        status: false
                    },
                    {
                        optionName: null,
                        status: false,
                    }
                ],
                questionName: null,
                score: null,
                topicId: null,
                questionType: 1,
                questionOptionType: 1,

            }
        }
    }
};
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>
